import { addChildNode, indexTree } from './domain.js';
import { localId, MAX_IMAGE_BYTES, validateDocumentSize } from './plant-document.js';

export function previewType(name = '') {
  const extension = name.split('.').pop().toLowerCase();
  return ({ pdf: 'application/pdf', png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg', webp: 'image/webp', gif: 'image/gif', txt: 'text/plain', csv: 'text/plain', json: 'text/plain', md: 'text/plain', log: 'text/plain' })[extension] || 'application/octet-stream';
}
// Keep legacy document ownership in storage, but exclude attachments from the
// physical hierarchy and all component navigation.
export function objectTree(tree) {
  return { ...tree, children: (tree.children || []).filter(node => node.type !== 'document').map(objectTree) };
}
export function attachDocument(document, parentId, attachment, id = localId('document')) {
  const parent = indexTree(document.tree).nodes.get(parentId);
  if (!parent || parent.type === 'document') throw new Error('invalidDocumentParent');
  const next = { ...document, tree: addChildNode(document.tree, parentId, { id, name: attachment.name, type: 'document', children: [] }), attachments: { ...document.attachments, [id]: attachment } };
  validateDocumentSize(next);
  return next;
}
export async function readAttachment(file) {
  if (!file) throw new Error('documentRequired');
  if (file.size > MAX_IMAGE_BYTES) throw new Error('attachmentTooLarge');
  const data = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1]);
    reader.onerror = () => reject(new Error('imageReadError'));
    reader.readAsDataURL(file);
  });
  return { name: file.name, size: file.size, data, uploadedAt: new Date().toISOString() };
}
export function removeDocument(document, id) {
  const node = indexTree(document.tree).nodes.get(id);
  if (!node || node.type !== 'document' || node.children?.length) throw new Error('invalidDocumentDeletion');
  const remove = tree => ({ ...tree, ...(tree.children ? { children: tree.children.filter(child => child.id !== id).map(remove) } : {}) });
  const attachments = { ...document.attachments };
  delete attachments[id];
  return { ...document, tree: remove(document.tree), attachments };
}
// Never trust an uploaded MIME type or execute HTML/SVG documents.
export function attachmentBlob(attachment) {
  const bytes = Uint8Array.from(atob(attachment.data), character => character.charCodeAt(0));
  return new Blob([bytes], { type: previewType(attachment.name) });
}
